import { animate, AUTO_STYLE, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { CalendarEvent, CalendarEventRegistration, CalendarEventRegistrationRequest, CoreLibService, LinkOpenMode, Mutation, PushNotificationInput, Query } from 'core-lib';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { environment } from 'projects/appointment-module/src/environments/environment';
import { Subscription } from 'rxjs';
import { AppointmentManagementListComponent } from '../appointment-management-list/appointment-management-list.component';
import { whiteButton, whiteButtonActive, whiteButtonLast, whiteButtonLastActive } from "../../../theme";
@Component({
  selector: 'lib-event-sign-ups-overview',
  templateUrl: './event-sign-ups-overview.component.html',
  styleUrls: ['./event-sign-ups-overview.component.scss'],
  animations: [
    trigger('collapse', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-out', style({ height: AUTO_STYLE, opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: AUTO_STYLE, opacity: 1 }),
        animate('200ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ],
  standalone: false
})
export class EventSignUpsOverviewComponent implements OnInit {

    hiddenElements = [];

  @Input() context: any
  @Output() closeEventSignUpsOverview = new EventEmitter<CalendarEvent>();
  protected readonly whiteButton = whiteButton;
  protected readonly whiteButtonActive = whiteButtonActive;
  protected readonly whiteButtonLast = whiteButtonLast;
  protected readonly whiteButtonLastActive = whiteButtonLastActive;

  event: CalendarEvent;
  canWrite: boolean = false;

  registrationForm: FormGroup;
  viewControl = { registrationVisible: false, signups: 0, waitingList: 0 };
  showPushDialog = false;
  //Loading the appropriate SignUps from the parsed event
  currentEventSignUps: CalendarEventRegistration[] = [];
  private loadEventSignUpsSubscription: Subscription;
  private loadEventSignUpsRef: QueryRef<Query>;
  QUERY_GET_SIGNUPS_FOR_EVENT = gql`
  query listCalendarEventRegistrations($calendarEventId: ID){
      listCalendarEventRegistrations(calendarEventId : $calendarEventId){
          calendarEventId
          id
          comment
          creationDate
          clientId
          status
          payed
          waitingPosition
          ticket{
            product{
              name
              price{
                currency
                amount
              }
              tax{
                rate
              }
            }
          
          }
          client{
            firstname
            name
            email
          }
          seat {
            id
            userProfileId
            name
            firstname
            email
            phoneNumber
            comment
          }
          formData
  }}`;


  /**
  * For User Profile Picture
  */
  apiURL = environment.apiURL;

  isNativeApp = false;
  //Deleting selected SignUps within the parsed event + Update the Eventdata after
  showCancelEventSignUpConfirm: boolean;
  currentEventSignUpID: any;
  private loadGetSignUpsForEventSubscription: Subscription;
  private loadGetSignUpsForEventRef: QueryRef<Query>;

  MUTATION_REQUEST_SEND_PUSH_NOTIFICATION = gql`
  mutation sendPushNotificationToEventAttendees($eventId: ID!,$profileIds:[String],$notification: PushNotificationInput){
    sendPushNotificationToEventAttendees(eventId : $eventId, profileIds : $profileIds,notification : $notification)}`;

  MUTATION_REQUEST_CANCEL_REGISTRATION = gql`
  mutation cancelCalendarEventRegistration($registrationId : ID!){
    cancelCalendarEventRegistration(registrationId : $registrationId){
      id
      seriesId
      title
      subTitle
      dateStart
      dateEnd
      registrationRequired
      ownRegistrations {
        status
        id
      }
  }}`;


  MUTATION_CONFIRM_EVENT_ATTENDANCE = gql`
  mutation confirmEventAttendance($registrationId : ID!){
    confirmEventAttendance(registrationId : $registrationId){
      status
      id
  }}`;

  MUTATION_REJECT_EVENT_ATTENDANCE = gql`
  mutation rejectEventAttendance($registrationId : ID!){
    rejectEventAttendance(registrationId : $registrationId){
      status
      id
  }}`;


  MUTATION_DEQUEUE = gql`
  mutation dequeueCalendarEventRegistration($registrationId : ID!){
    dequeueCalendarEventRegistration(registrationId : $registrationId){
      id
  }}`;

  MUTATION_CONFIRM_EVENT_PAYMENT = gql`
  mutation confirmEventPayment($registrationId : ID!){
    confirmEventPayment(registrationId : $registrationId){
      payed
      id
  }}`;

  MUTATION_ENFORCE_EVENT_REGISTRATION = gql`
  mutation enforceCalendarEventRegistration($request : CalendarEventRegistrationRequest){
    enforceCalendarEventRegistration(request : $request){
      calendarEventId
      id
      comment
      creationDate
      clientId
      status
      payed
      client{
        firstname
        name
        email
      }
      seat {
        id
        userProfileId
        name
        firstname
        email
        phoneNumber
        comment
      }
  }}`;

  MUTATION_REJECT_EVENT_PAYMENT = gql`
  mutation rejectEventPayment($registrationId : ID!){
    rejectEventPayment(registrationId : $registrationId){
      payed
      id
  }}`;

  QUERY_GET_CURRENT_EVENT = gql`
  query getCalendarEventById($calendarEventId: ID!){
    getCalendarEventById(calendarEventId: $calendarEventId) {
       ${AppointmentManagementListComponent.CALENDAR_EVENT_FIELDS}
  }}`;
  MUTATION_DELETE_TARGET_SEAT = gql`
  mutation cancelSeatFromCalendarEventRegistration($registrationId : ID!, $seatId : String!){
    cancelSeatFromCalendarEventRegistration(registrationId : $registrationId, seatId: $seatId){
      calendarId
  }}`;

  QUERY_LOAD_EXTENDED_REGISTRATION_FORM = gql`
  query getCalendarRegistrationForm($id: ID!){
    getCalendarRegistrationForm(id : $id){
      id header footer fields{ columnName propertyName datatype mandatory}
    }
  }`;

  constructor(private apolloClient: Apollo, private confirmationService: ConfirmationService, private messageService: MessageService, public coreService: CoreLibService, @Inject('component') private component: string,) { }

  ngOnInit(): void {
    this.event = this.context.event;
    this.canWrite = this.event.canWrite;
    this.loadEventSignUps(this.event.id);

    if (this.event.registrationFormId) {
      this.apolloClient.query<Query>({
        query: this.QUERY_LOAD_EXTENDED_REGISTRATION_FORM,
        variables: {
          id: this.event.registrationFormId
        }
      }).subscribe((result) => {
        this.event.registrationForm = result.data.getCalendarRegistrationForm;
      });
    }

    this.isNativeApp = this.coreService.isNativeApp();

    this.registrationForm = new FormGroup({
      "firstname": new FormControl(null, [Validators.required]),
      "name": new FormControl(null, [Validators.required]),
      "email": new FormControl(null, [Validators.email]),
      "phoneNumber": new FormControl(null),
      "comment": new FormControl(null),
    });
  }

  ngOnDestroy(): void {
    if (this.loadEventSignUpsSubscription != null) {
      this.loadEventSignUpsSubscription.unsubscribe();
    }
    if (this.loadGetSignUpsForEventSubscription != null) {
      this.loadGetSignUpsForEventSubscription.unsubscribe();
    }
  }

  loadEventSignUps(calendarEventId): void {
    this.loadEventSignUpsRef = this.apolloClient.watchQuery<Query>({
      query: this.QUERY_GET_SIGNUPS_FOR_EVENT,
      variables: {
        calendarEventId: calendarEventId
      }
    });

    this.loadEventSignUpsSubscription = this.loadEventSignUpsRef.valueChanges.subscribe((result) => {
      this.currentEventSignUps = result.data.listCalendarEventRegistrations;
      this.bkupSignUps = result.data.listCalendarEventRegistrations;
      this.viewControl.signups = 0;
      this.viewControl.waitingList = 0;
      for (const signup of this.currentEventSignUps) {
        if (signup.status === 'CONFIRMED' || signup.status === 'ATTENDED') {
          this.viewControl.signups++;
        } else if (signup.status === 'QUEUED') {
          this.viewControl.waitingList++;
        }
      }
    });
  }

  onShowDisplayCancelEventSignUpConfirm(targetSignUpID): void {
    this.showCancelEventSignUpConfirm = true;
    this.currentEventSignUpID = targetSignUpID;
  }

  cancelUserSignUp(signUp): void {
    this.onCancelSignUp(signUp.id).subscribe((result) => {
      this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
      this.currentEventSignUpID = null;
      this.showCancelEventSignUpConfirm = false;
      this.reloadEventData();
    });
  }

  @HostListener('window:qr-code-scanned', ['$event'])
  confirmEventByCode(event: any) {
    const registrationId = event.detail;
    const signUp = this.currentEventSignUps.find((signUp) => signUp.id === registrationId);
    if (!signUp) {
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@event-sign-ups-overview.no-record-found: No matching record was found.`
      });
      return;
    }
    this.confirmEventAttendance(signUp);
    document.getElementById(registrationId).scrollIntoView();
  }


  confirmEventAttendance(registration: CalendarEventRegistration) {
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_CONFIRM_EVENT_ATTENDANCE,
      variables: {
        registrationId: registration.id
      }
    }).subscribe((result) => {
      if (result && result.data) {
        registration.status = result.data.confirmEventAttendance.status;
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.confirmAttendance.message: Participation has been confirmed.`
        });
        this.reloadEventData();
      }
    });
  }

  rejectEventAttendance(registration: CalendarEventRegistration) {
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_REJECT_EVENT_ATTENDANCE,
      variables: {
        registrationId: registration.id
      }
    }).subscribe((result) => {
      if (result && result.data) {
        registration.status = result.data.rejectEventAttendance.status;
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.confirmAttendance-revoked.message:Participation has been revoked.`
        });
        this.reloadEventData();
      }
    })
  }


  confirmEventPayment(registration: CalendarEventRegistration) {
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_CONFIRM_EVENT_PAYMENT,
      variables: {
        registrationId: registration.id
      }
    }).subscribe((result) => {
      if (result && result.data) {
        registration.payed = result.data.confirmEventPayment.payed;
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.payment-confirmed.message:Payment has been confirmed.`
        });
        this.reloadEventData();
      }
    });
  }

  rejectEventPayment(registration: CalendarEventRegistration) {
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_REJECT_EVENT_PAYMENT,
      variables: {
        registrationId: registration.id
      }
    }).subscribe((result) => {
      if (result && result.data) {
        registration.payed = result.data.rejectEventPayment.payed;
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.payment-revoked.message:Payment has been revoked.`
        });
        this.reloadEventData();
      }
    })
  }


  /**
   * Platz Warteschlange umwalden in Teilnahme
   * @param registration
   */
  dequeueCalendarEventRegistration(registration: CalendarEventRegistration) {
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_DEQUEUE,
      variables: {
        registrationId: registration.id
      }
    }).subscribe((result) => {
      this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
      this.reloadEventData();
    })
  }


  onCancelSignUp(registrationId) {
    return this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_REQUEST_CANCEL_REGISTRATION,
      variables: {
        registrationId: registrationId
      }
    });
  }

  onExportToExcel() {
    const url = `${this.apiURL}/file-api/calendar-event/${this.event.id}/attendance-list?access_token=${this.coreService.getJWTToken()}`;
    this.coreService.openLink(url, LinkOpenMode.External, null);
  }
  //To fetch the total amount of signups from an event after signing up
  reloadEventData() {
    this.loadGetSignUpsForEventRef = this.apolloClient.watchQuery<Query>({
      query: this.QUERY_GET_CURRENT_EVENT,
      variables: {
        calendarEventId: this.event.id
      }
    })

    //emit result as CalendarEvent
    this.loadGetSignUpsForEventSubscription = this.loadGetSignUpsForEventRef.valueChanges.subscribe((result) => {
      this.event.registrationCount = result.data["getCalendarEventById"].registrationCount;
      this.closeEventSignUpsOverview.emit(this.event);
    });
  }

  onSendPushNotification(pushMessageArea: any): void {
    const text = pushMessageArea.value;
    const input = {} as PushNotificationInput;
    input.message = text;
    input.componentId = this.component;

    const profileIds = [];
    for (const signup of this.currentEventSignUps) {
      if (signup.seat.userProfileId) {
        profileIds.push(signup.seat.userProfileId);
      }
    }

    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_REQUEST_SEND_PUSH_NOTIFICATION,
      variables: {
        eventId: this.event.id,
        profileIds: profileIds,
        notification: input
      }
    }).subscribe((result) => {
      if (!result.errors) {
        this.showPushDialog = false;
        pushMessageArea.value = "";
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.push.success: Push message has been sent.`
        });
      }
    });


  }
  onClickCancelSignUp(signUp) {
    this.confirmationService.confirm({
      message: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.message: Do you really want to cancel this registration?`,
      header: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.header: Cancel registration`,
      rejectLabel: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.rejectLabel: No`,
      acceptLabel: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.acceptLabel: Yes`,
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      defaultFocus: 'none',
      accept: () => {
        this.onCancelSignUp(signUp.id).subscribe((result) => {
          this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
          this.currentEventSignUpID = null;
          this.showCancelEventSignUpConfirm = false;
          this.messageService.add({
            severity: 'info',
            summary: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.summary: Registration cancelled`,
          });
          this.reloadEventData();
        });
      },
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            console.log("reject")
            break;
          case ConfirmEventType.CANCEL:
            console.log("cancel")
            break;
        }
      }
    });
  }

  onMailTargetClient(email: String) {
    window.location.href = `mailto:${email}`;
  }

  onPhoneTargetClient(phone: String) {
    window.location.href = `tel:${phone}`;
  }

  onClickCancelSeat(seat, eventSignUps): void {
    this.confirmationService.confirm({
      message: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.message: Do you really want to cancel this registration?`,
      header: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.header: Cancel registration`,
      rejectLabel: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.rejectLabel: No`,
      acceptLabel: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.acceptLabel: Yes`,
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      defaultFocus: 'none',
      accept: () => {
        this.apolloClient.mutate<Mutation>({
          mutation: this.MUTATION_DELETE_TARGET_SEAT,
          variables: {
            registrationId: eventSignUps[0].id,
            seatId: seat.id
          }
        }).subscribe((result) => {
          this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
          this.messageService.add({
            severity: 'info',
            summary: $localize`:@@event-sign-ups-overview.cancelRegistration.messageService.summary: Registration cancelled`,
          });
          this.reloadEventData();
        })
      },
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            console.log("reject")
            break;
          case ConfirmEventType.CANCEL:
            console.log("cancel")
            break;
        }
      }
    });
  }


  onOpenChatWithUser(userProfileId): void {
    window.open("directchat://" + userProfileId)
  }

  openQRCodeScanner() {
    const app = window['App'];
    if (this.coreService.isNativeAndroid()) {
      app.openCodeScannerV2();
    } else if (this.coreService.isNativeIOS()) {
      app.openCodeScannerV2().then((result) => {
        if (result.id) {
          this.confirmEventByCode({ detail: result.id });;
        } else {
          this.messageService.add({
            severity: 'info',
            summary: $localize`:@@event-sign-ups-overview.qr-code-scan-failed: Unfortunately, scanning the QR code failed.`
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: $localize`:@@event-sign-ups-overview.qr-code-scanner-not-supported: This feature is only supported on native IOS and Android devices.`
      });
    }

  }
  /**
   * Filterlogik
   */
  //Backup Array to cache SignUps
  bkupSignUps = this.currentEventSignUps;
  onSearchBarKeyUp(eventTarget: EventTarget): void {
    let target = eventTarget as HTMLInputElement;
    let value: string = target.value;
    this.currentEventSignUps = this.bkupSignUps;
    value = value.toLowerCase();

    this.currentEventSignUps = this.currentEventSignUps.filter((signUp) => {
      let matches = false;

      if (signUp.client && (signUp.client.name.toLowerCase().includes(value) || signUp.client.firstname.toLowerCase().includes(value))) {
        matches = true;
      }
      if (signUp.seat.name.toLowerCase().includes(value) || signUp.seat.firstname.toLowerCase().includes(value)) {
        matches = true;
      }

      return matches;
    });
  }

  activeSorting: SignUpSorting;
  allSignUpSortingFlags: Object[];
  signUpSortingOptions = [
    {
      id: SignUpSorting.NoSort,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.noSort: No sorting`
    },
    {
      id: SignUpSorting.LastName,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.lastName: Sort by last name`
    },
    {
      id: SignUpSorting.LastNameReverse,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.lastNameReverse: Sort by last name, reversed`
    },
    {
      id: SignUpSorting.DateTime,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.dateTime: Sort by time of registration`
    },
    {
      id: SignUpSorting.DateTimeReverse,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.dateTimeReverse: Sort by time of registration, reverse`
    },
    {
      id: SignUpSorting.OwnSignUp,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.ownSignUp: Only show your registrations`
    },
    {
      id: SignUpSorting.Not_Attended,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.notAttended: Show participants who were not present`
    },
    {
      id: SignUpSorting.Not_Payed,
      label: $localize`:@@event-sign-ups-overview.sortingOptions.notPayed: Show participants who haven't payed`
    }
  ]

  onApplyFilter() {
    let flag: SignUpSorting = this.activeSorting;

    switch (flag) {
      case SignUpSorting.NoSort:
        this.currentEventSignUps = this.bkupSignUps;
        break;
      case SignUpSorting.LastName:
        this.onFilterByLastName(SignUpSorting.LastName);
        break;
      case SignUpSorting.LastNameReverse:
        this.onFilterByLastName(SignUpSorting.LastNameReverse);
        break;
      case SignUpSorting.DateTime:
        this.onFilterBySignUpTime(SignUpSorting.DateTime);
        break;
      case SignUpSorting.DateTimeReverse:
        this.onFilterBySignUpTime(SignUpSorting.DateTimeReverse);
        break;
      case SignUpSorting.Not_Attended:
        this.onFilterByNotAttended(SignUpSorting.Not_Attended);
        break;
      case SignUpSorting.Not_Payed:
        this.onFilterByNotPayed(SignUpSorting.Not_Payed);
        break;
      case SignUpSorting.OwnSignUp:
        this.onSearchForOwnSignUp(this.coreService.getSecurityInformation().userProfile.id);
        break;
      default:
        break;
    }
  }

  onSearchForOwnSignUp(userProfileId) {
    this.currentEventSignUps = this.bkupSignUps;
    this.activeSorting = SignUpSorting.OwnSignUp;
    this.currentEventSignUps = this.currentEventSignUps.filter((signUp) => {
      return signUp.clientId == userProfileId;
    });
  }

  onFilterBySignUpTime(flag: SignUpSorting) {
    this.currentEventSignUps = this.bkupSignUps;

    var sortedArr = this.currentEventSignUps.sort(function (a, b) {
      var key1 = new Date(a.creationDate);
      var key2 = new Date(b.creationDate);
      return key1.valueOf() - key2.valueOf();
    });

    if ((flag & SignUpSorting.DateTime) === SignUpSorting.DateTime) {
      this.currentEventSignUps = sortedArr;
    }
    else if ((flag & SignUpSorting.DateTimeReverse) === SignUpSorting.DateTimeReverse) {
      this.currentEventSignUps = sortedArr.reverse();
    }
  }

  onFilterByNotAttended(flag: SignUpSorting) {
    this.currentEventSignUps = this.bkupSignUps;
    this.activeSorting = flag;
    this.currentEventSignUps = this.currentEventSignUps.filter((signUp) => {
      return signUp.status !== 'ATTENDED';
    });
  }

  onFilterByNotPayed(flag: SignUpSorting) {
    this.currentEventSignUps = this.bkupSignUps;
    this.activeSorting = flag;
    this.currentEventSignUps = this.currentEventSignUps.filter((signUp) => {
      return signUp.payed == false;
    });
  }

  onFilterByLastName(flag: SignUpSorting) {
    this.currentEventSignUps = this.bkupSignUps;

    var sortedArr = this.currentEventSignUps.sort(function (a, b) {
      var key1 = a.seat.name;
      var key2 = b.seat.name;

      if (key1 < key2) {
        return -1;
      }
      if (key1 > key2) {
        return 1;
      }
      return 0;
    });

    if ((flag & SignUpSorting.LastName) === SignUpSorting.LastName) {
      this.currentEventSignUps = sortedArr;
    }
    else if ((flag & SignUpSorting.LastNameReverse) === SignUpSorting.LastNameReverse) {
      this.currentEventSignUps = sortedArr.reverse();
    }
  }

  /**
   *
   * Versenden der Anmeldeliste
   */

  onClickSendSignUpList() {
    this.confirmationService.confirm({
      message: $localize`:@@event-sign-ups-overview.sendSignUpList.messageService.message: Do you really want to send a list of attendees to the appointment manager(s) of this event?`,
      header: $localize`:@@event-sign-ups-overview.sendSignUpList.messageService.header: Send Attendee list`,
      rejectLabel: $localize`:@@event-sign-ups-overview.sendSignUpList.messageService.rejectLabel: No`,
      acceptLabel: $localize`:@@event-sign-ups-overview.sendSignUpList.messageService.acceptLabel: Yes`,
      acceptButtonStyleClass: 'p-button-secondary',
      rejectButtonStyleClass: 'p-button-secondary',
      defaultFocus: 'none',
      accept: () => {
        this.generateSignUpEmail();
      },
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            console.log("reject");
            break;
          case ConfirmEventType.CANCEL:
            console.log("cancel");
            break;
        }
      }
    });
  }

  generateSignUpEmail() {
    let userList = [];
    for (let index = 0; index < this.currentEventSignUps.length; index++) {
      const element = this.currentEventSignUps[index];
      const seat = element.seat[index];
      let user = [seat.firstname, seat.name, seat.email, seat.phoneNumber].filter(Boolean).join(", ");
      userList.push(user);
    }
  }

  onModalShow(modal: string) {
    let elem = document.getElementById(modal).querySelectorAll(".p-dialog-close-button").item(0) as HTMLElement;
    elem.focus();
  }

  /**
   * Modal: Admin Anmeldung

  displayAdminSignUp: Boolean = false;
  onDisplayAdminSignUp(){
    this.displayAdminSignUp = !this.displayAdminSignUp;
  }*/

  onUpdateAfterAdminSignUp() {
    this.reloadEventData();
    this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
  }

  onAddParticipant(): void {
    this.registrationForm.markAllAsTouched();
    if (this.registrationForm.valid) {
      let request = {
        calendarEventId: this.event.id,
        attendees: [this.registrationForm.getRawValue()]
      } as CalendarEventRegistrationRequest;
      this.viewControl.registrationVisible = false;
      this.apolloClient.mutate<Mutation>({
        mutation: this.MUTATION_ENFORCE_EVENT_REGISTRATION,
        variables: {
          request: request
        }
      }).subscribe((result) => {
        this.messageService.add({
          severity: 'success',
          summary: $localize`:@@event-sign-ups-overview.confirm-admin-registration:Participants added to event`
        });
        this.reloadEventData();
        this.loadEventSignUpsRef.refetch({ calendarEventId: this.event.id });
        this.registrationForm.reset();
      });
    }
    else {
      this.scrollToFirstInvalidControl();
    }}

      scrollToFirstInvalidControl() {
    let form = document.getElementById('registrationForm');
    let firstInvalidControl = form.getElementsByClassName('ng-invalid')[0];
    firstInvalidControl.scrollIntoView();
    (firstInvalidControl as HTMLElement).focus();
  }

   hideElementsOnIOS() {
    for (let id of this.hiddenElements) {
      let element = document.getElementById(id);
      if(element != null && !element.getAttribute("aria-hidden")) {
        element?.setAttribute("aria-hidden", "true");
      }
    }
  }
  }

export enum SignUpSorting {
  NoSort,
  LastName,
  LastNameReverse,
  DateTime,
  DateTimeReverse,
  OwnSignUp,
  Not_Attended,
  Not_Payed
}




